import { OldAndNewCategories } from '@lambda/apis/src/category/types';
import { Logger } from '@lambda/commons/logging/logger';
import axios from 'axios';
import { Breakpoints } from '@/settings/breakpoints';
import settings from '@/settings';

const logger = new Logger('CATEGORY_HELPERS');

export const breakpoints = {
  [Breakpoints.NONE]: {
    slidesPerView: 1.5,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.XS]: {
    slidesPerView: 2.5,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.MD]: {
    slidesPerView: 3.5,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  [Breakpoints.LG]: {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 10,
  },
  [Breakpoints.XL]: {
    slidesPerView: 5,
    slidesPerGroup: 5,
    spaceBetween: 10,
  },
};

// Generate Handle
export const splitAndJoinWithDash = (str: string) =>
  str
    .toLowerCase()
    .split(/[^a-zA-Z]+/)
    .join('-');

export const t = (word: string): string => {
  const isAUStore = settings.store === 'reebelo-au';

  switch (word) {
    case 'favorite':
      if (isAUStore) return 'favourite';
      break;
    case 'used':
      if (isAUStore) return 'preloved';
      break;
    case 'sanitizing':
      if (isAUStore) return 'sanitising';
      break;
    case 'sanitized':
      if (isAUStore) return 'sanitised';
      break;
    case 'mom':
      if (isAUStore) return 'mum';
      break;
    default:
      return word;
  }

  return word;
};

export const getCategoryMappings = async (categories: string[]) => {
  try {
    const response = await axios.post<OldAndNewCategories>(
      '/api/categories/mapping',
      { categories },
    );

    const mappedCategories = response.data;

    return mappedCategories;
  } catch (err) {
    logger.error({ err }, 'Error fetching mapped categories');

    return null;
  }
};
